import React from 'react';
import PlatformServicePage from './PlatformServicePage';
const TikTokServices: React.FC = () => <PlatformServicePage platform="tiktok" />;
export default TikTokServices;
